import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Box, Button, Text, Spacer, useColorMode, IconButton } from "@chakra-ui/react";
import SettingsMenu from "../../components/common/SettingsMenu";

import { ReactComponent as DownloadIcon } from "../../assets/icons/download_2_fill_icon.svg";

const FeedbackHeader = ({ handleDownload }) => {
  const { colorMode } = useColorMode();
  const history = useHistory();

  const handleCreateClick = () => {
    history.push("/admin/feedback");
  };

  const handleResponsesClick = () => {
    history.push("/admin/feedback-response");
  };

  return (
    <Box
      flex="1"
      display="flex"
      flexDirection="column"
      pb={0}
      maxH="8vh"
      borderBottom="1px"
      borderColor="blackAlpha.200"
      overflowY="hidden"
    >
      <Box
        display="flex"
        alignItems="center"
        bg={colorMode === "dark" ? "gray.700" : "white"}
        width="100%"
        height="100%"
        p={4}
        boxSizing="border-box"
        overflowY="hidden"
      >
        <Text
          fontSize="md"
          fontWeight="bold"
          mb={0}
          mt={0}
          color={colorMode === "dark" ? "gray.200" : "blackAlpha.700"}
        >
          Feedback Responses
        </Text>

        <Spacer />
        {/* Download button */}
        <IconButton
          aria-label="Download Excel"
          icon={<Box as={DownloadIcon} boxSize="5" />}
          color="green"
          bg="none"
          _hover="none"
          size="lg"
          onClick={handleDownload}
        />

        <Button
          bg="gray.300"
          color="black"
          _hover="none"
          size="sm"
          onClick={handleCreateClick}
          ml={2}
        >
          Create Survey
        </Button>

        <Button
          border="1px solid"
          bg="#286328"
          borderColor="#286328"
          color="white"
          _hover="none"
          size="sm"
          onClick={handleResponsesClick}
          ml={2}
        >
          Responses
        </Button>
        <SettingsMenu />
      </Box>
    </Box>
  );
};

export default FeedbackHeader;
